import { render, staticRenderFns } from "./SortableColumnHeader.vue?vue&type=template&id=2d97f298&scoped=true&"
import script from "./SortableColumnHeader.vue?vue&type=script&lang=js&"
export * from "./SortableColumnHeader.vue?vue&type=script&lang=js&"
import style0 from "./SortableColumnHeader.vue?vue&type=style&index=0&id=2d97f298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97f298",
  null
  
)

export default component.exports